import React from 'react'

import { Skeleton } from 'antd'
import {
  CardText,
  CardValue,
  SingleCard,
} from 'components/InfoCardsUpdate/style'
import { IconTextContainer, TextWrapper } from './style'

const InfoCardsUpdate = ({
  background,
  padding = '15px 25px',
  width = 'auto',
  height,
  icon,
  text,
  value,
  onClick,
  isSelected = false,
  borderColor,
  loading,
  IconText,
  isClickable,
  style,
  isSlim = false,
}) => {
  return (
    <SingleCard
      data-test={background}
      background={background}
      padding={padding}
      width={width}
      height={height}
      column={!isSlim}
      row={isSlim}
      flexStart
      onClick={onClick}
      borderColor={borderColor}
      isClickable={isClickable}
      style={style}
    >
      <IconTextContainer>
        {icon}
        <CardText isSelected={isSelected}>{text}</CardText>
      </IconTextContainer>
      {loading ? (
        <Skeleton.Avatar active={true} size={'default'} shape={'square'} />
      ) : (
        <CardValue isSelected={isSelected} isSlim={isSlim}>{value}</CardValue>
      )}
    </SingleCard>
  )
}

export default InfoCardsUpdate